export default __webpack_public_path__ + "static/media/sportello_selezionato.bcdc78b4.less";